import * as Yup from 'yup';
import { DataLists } from '../../../../services/data/data.types';
import { FormErrorMessages, nameSchema } from 'utils/formValidation';

export const UserInfoFormSchema = (datalists: DataLists) =>
    Yup.object().shape({
        firstname: nameSchema,
        lastname: nameSchema,
        phone: Yup.string()
            .matches(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, FormErrorMessages.phone_invalid)
            .required(FormErrorMessages.required)
            .test({
                name: 'unique-phone',
                exclusive: true,
                message: FormErrorMessages.phone_exists,
                test: async (value?: string) => {
                    return !!value;
                }
            }),
        email: Yup.string()
            .email(FormErrorMessages.email_invalid)
            .optional()
            .test({
                name: 'unique-email',
                exclusive: true,
                message: FormErrorMessages.email_exists,
                test: async (value?: string) => {
                    return !!value;
                }
            }),
        color: Yup.string()
            .oneOf(Object.values(datalists?.agenda_colors || {}), FormErrorMessages.color_invalid)
            .optional()
    });
